import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import SiteEditor from './pages/SiteEditor';
import GiftManager from './pages/GiftManager';
import GuestManager from './pages/GuestManager';
import FinancesPage from './pages/FinancesPage';
import CreativeStudioPage from './pages/CreativeStudioPage';
import PublicSite from './pages/PublicSite';
import PlansPage from './pages/PlansPage';
import SupplierRegister from './pages/SupplierRegister';
import SupplierLogin from './pages/SupplierLogin';
import SupplierDashboard from './pages/SupplierDashboard';
import SupplierMarketingPage from './pages/SupplierMarketingPage';
import SupplierDirectoryPage from './pages/SupplierDirectoryPage';
import SupplierProfilePage from './pages/SupplierProfilePage';
import SuppliersComingSoonPage from './pages/SuppliersComingSoonPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CookieConsentBanner from './components/CookieConsentBanner';
import GoogleTagManager from './components/GoogleTagManager';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F6F1EF]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#E8B7B1] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#333333] font-medium">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage showCouponBanner />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/planos" element={<PlansPage />} />
      <Route path="/site-de-casamento" element={<LandingPage seoKey="weddingSite" />} />
      <Route path="/lista-de-presentes-casamento" element={<LandingPage seoKey="giftList" />} />
      <Route path="/convite-digital-casamento" element={<LandingPage seoKey="digitalInvite" />} />
      <Route path="/save-the-date" element={<LandingPage seoKey="saveTheDate" />} />
      <Route path="/rsvp-casamento" element={<LandingPage seoKey="rsvp" />} />
      <Route path="/presente-de-casamento-pix" element={<LandingPage seoKey="pixGift" />} />
      <Route path="/s/:slug" element={<PublicSite />} />
      <Route path="/fornecedores-beta" element={<SuppliersComingSoonPage />} />
      <Route path="/fornecedores" element={<SupplierDirectoryPage />} />
      <Route path="/fornecedores/anuncie" element={<SupplierMarketingPage />} />
      <Route path="/fornecedores/:slug" element={<SupplierProfilePage />} />
      
      {/* Supplier/Affiliate Routes (Hidden) */}
      <Route path="/fornecedor/cadastro" element={<SupplierRegister />} />
      <Route path="/fornecedor/login" element={<SupplierLogin />} />
      <Route path="/fornecedor/painel" element={<SupplierDashboard />} />
      
      {/* Admin Routes (Hidden) */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/painel" element={<AdminDashboard />} />
      
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/editor" element={
        <ProtectedRoute>
          <SiteEditor />
        </ProtectedRoute>
      } />
      <Route path="/gifts" element={
        <ProtectedRoute>
          <GiftManager />
        </ProtectedRoute>
      } />
      <Route path="/guests" element={
        <ProtectedRoute>
          <GuestManager />
        </ProtectedRoute>
      } />
      <Route path="/finances" element={
        <ProtectedRoute>
          <FinancesPage />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/convites-artes" element={
        <ProtectedRoute>
          <CreativeStudioPage />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <GoogleTagManager />
        <AppRouter />
        <CookieConsentBanner />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

